// extracted by mini-css-extract-plugin
export var content = "GiftCheckout-module__content___o0ZE4";
export var heading = "GiftCheckout-module__heading___f611h";
export var link = "GiftCheckout-module__link___gJbja";
export var logo = "GiftCheckout-module__logo___KYd02";